<template>
  <div id="output" class="flex h-100 flex-wrap pagebgd" style="overflow: hidden">
    <div @click="back()" class="power">
      <i style="cursor: pointer;" class="el-icon-back"></i>
    </div>
    <div class="etime">{{ now }}</div>
    <div class="etime1">最后更新:{{ updateTimeText }}</div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <dv-decoration-5 :dur="10" style="position: absolute; bottom: 0; right: 0; height: 50%" class="w-100" />
      <div class="font-big font-weight light-title">
        {{ title }}
      </div>
    </header>
    <div class="w-100 h-90 flex j-center a-center" style="padding:10px">
      <table class="table-wrapper h-100">
        <thead>
          <tr
            style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
            <th colspan="2" rowspan="2">Product</th>
            <th rowspan="2">成品数量</th>
            <th colspan="2" :class="{ 'highlight': week == '星期一' }">Mon</th>
            <th colspan="2" :class="{ 'highlight': week == '星期二' }">Tue</th>
            <th colspan="2" :class="{ 'highlight': week == '星期三' }">Wed</th>
            <th colspan="2" :class="{ 'highlight': week == '星期四' }">Thu</th>
            <th colspan="2" :class="{ 'highlight': week == '星期五' }">Fri</th>
            <th colspan="2" :class="{ 'highlight': week == '星期六' }">Sat</th>
            <th colspan="2" :class="{ 'highlight': week == '星期日' }">Sun</th>
            <th rowspan="2">Total Gap</th>
          </tr>
          <tr
            style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
            <th style="font-weight:100;font-size: 0.35rem;color:white">Plan</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Act</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Plan</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Act</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Plan</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Act</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Plan</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Act</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Plan</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Act</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Plan</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Act</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Plan</th>
            <th style="font-weight:100;font-size: 0.35rem;color:white">Act</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(tr, ind) in leftValue">
            <tr :key="'leftValue-' + ind">
              <td style="width: 1.5rem;" :rowspan="tr.list.length" class="light-title font-weight">
                {{ tr.title }}
              </td>
              <td style="width:3.5rem;">{{ tr.list[0].title }}</td>
              <td style="width:2.0rem;">{{ tr.list[0].stocks }}</td>
              <td>
                <span v-if="tr.list[0].outProduceMap['0'].forecast!=null">{{ tr.list[0].outProduceMap["0"].forecast }}</span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{
                  'color': (tr.list[0].outProduceMap['0'] && tr.list[0].outProduceMap['0']['isRed']) ? 'red' : 'green',
                }" v-if="tr.list[0].outProduceMap['0'].actual!=null">
                  {{ tr.list[0].outProduceMap["0"].actual }}
                </span>
                <span v-else> </span>
              </td>
              <td>
                <span v-if="tr.list[0].outProduceMap['1'].forecast!=null">{{ tr.list[0].outProduceMap["1"].forecast }}</span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{
                  'color': (tr.list[0].outProduceMap['1'] && tr.list[0].outProduceMap['1']['isRed']) ? 'red' : 'green',
                }" v-if="tr.list[0].outProduceMap['1'].actual!=null">
                  {{ tr.list[0].outProduceMap["1"].actual }}
                </span>
                <span v-else> </span>
              </td>
              <td>
                <span v-if="tr.list[0].outProduceMap['2'].forecast!=null">{{ tr.list[0].outProduceMap["2"].forecast }}</span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{
                  'color': (tr.list[0].outProduceMap['2'] && tr.list[0].outProduceMap['2']['isRed']) ? 'red' : 'green',
                }" v-if="tr.list[0].outProduceMap['2'].actual!=null">
                  {{ tr.list[0].outProduceMap["2"].actual }}
                </span>
                <span v-else> </span>
              </td>
              <td>
                <span v-if="tr.list[0].outProduceMap['3'].forecast!=null">{{ tr.list[0].outProduceMap["3"].forecast }}</span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{
                  'color': (tr.list[0].outProduceMap['3'] && tr.list[0].outProduceMap['3']['isRed']) ? 'red' : 'green',
                }" v-if="tr.list[0].outProduceMap['3'].actual!=null">
                  {{ tr.list[0].outProduceMap["3"].actual }}
                </span>
                <span v-else> </span>
              </td>
              <td>
                <span v-if="tr.list[0].outProduceMap['4'].forecast!=null">{{ tr.list[0].outProduceMap["4"].forecast }}</span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{
                  'color': (tr.list[0].outProduceMap['4'] && tr.list[0].outProduceMap['4']['isRed']) ? 'red' : 'green',
                }" v-if="tr.list[0].outProduceMap['4'].actual!=null">
                  {{ tr.list[0].outProduceMap["4"].actual }}
                </span>
                <span v-else> </span>
              </td>
              <td>
                <span v-if="tr.list[0].outProduceMap['5'].forecast!=null">{{ tr.list[0].outProduceMap["5"].forecast }}</span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{
                  'color': (tr.list[0].outProduceMap['5'] && tr.list[0].outProduceMap['5']['isRed']) ? 'red' : 'green',
                }" v-if="tr.list[0].outProduceMap['5'].actual!=null">
                  {{ tr.list[0].outProduceMap["5"].actual }}
                </span>
                <span v-else> </span>
              </td>
              <td>
                <span v-if="tr.list[0].outProduceMap['6'].forecast!=null">{{ tr.list[0].outProduceMap["6"].forecast }}</span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{
                  'color': (tr.list[0].outProduceMap['6'] && tr.list[0].outProduceMap['6']['isRed']) ? 'red' : 'green',
                }" v-if="tr.list[0].outProduceMap['6'].actual!=null">
                  {{ tr.list[0].outProduceMap["6"].actual }}
                </span>
                <span v-else> </span>
              </td>
              <td>
                <span :style="{ 'color': (tr.list[0].total < 0) ? 'red' : 'green' }">
                  {{ tr.list[0].total }}
                </span>
              </td>
            </tr>
            <template v-for="(td, ix) in tr.list">
              <tr v-if="ix > 0" :key="'leftValue-' + ind + ix">
                <td>
                  {{ td.title }}
                </td>
                <td>
                  {{ td.stocks }}
                </td>
                <td>
                  <span v-if="td.outProduceMap['0'].forecast!=null">{{ td.outProduceMap["0"].forecast }}</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{
                    'color': (td.outProduceMap['0'] && td.outProduceMap['0']['isRed']) ? 'red' : 'green',
                  }" v-if="td.outProduceMap['0'].actual!=null">
                    {{ td.outProduceMap["0"].actual }}
                  </span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="td.outProduceMap['1'].forecast!=null">{{ td.outProduceMap["1"].forecast }}</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{
                    'color': (td.outProduceMap['1'] && td.outProduceMap['1']['isRed']) ? 'red' : 'green',
                  }" v-if="td.outProduceMap['1'].actual!=null">
                    {{ td.outProduceMap["1"].actual }}
                  </span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="td.outProduceMap['2'].forecast!=null">{{ td.outProduceMap["2"].forecast }}</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{
                    'color': (td.outProduceMap['2'] && td.outProduceMap['2']['isRed']) ? 'red' : 'green',
                  }" v-if="td.outProduceMap['2'].actual!=null">
                    {{ td.outProduceMap["2"].actual }}
                  </span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="td.outProduceMap['3'].forecast!=null">{{ td.outProduceMap["3"].forecast }}</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{
                    'color': (td.outProduceMap['3'] && td.outProduceMap['3']['isRed']) ? 'red' : 'green',
                  }" v-if="td.outProduceMap['3'].actual!=null">
                    {{ td.outProduceMap["3"].actual }}
                  </span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="td.outProduceMap['4'].forecast!=null">{{ td.outProduceMap["4"].forecast }}</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{
                    'color': (td.outProduceMap['4'] && td.outProduceMap['4']['isRed']) ? 'red' : 'green',
                  }" v-if="td.outProduceMap['4'].actual!=null">
                    {{ td.outProduceMap["4"].actual }}
                  </span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="td.outProduceMap['5'].forecast!=null">{{ td.outProduceMap["5"].forecast }}</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{
                    'color': (td.outProduceMap['5'] && td.outProduceMap['5']['isRed']) ? 'red' : 'green',
                  }" v-if="td.outProduceMap['5'].actual!=null">
                    {{ td.outProduceMap["5"].actual }}
                  </span>
                  <span v-else> </span>
                </td>
                <td>
                  <span v-if="td.outProduceMap['6'].forecast!=null">{{ td.outProduceMap["6"].forecast }}</span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{
                    'color': (td.outProduceMap['6'] && td.outProduceMap['6']['isRed']) ? 'red' : 'green',
                  }" v-if="td.outProduceMap['6'].actual!=null">
                    {{ td.outProduceMap["6"].actual }}
                  </span>
                  <span v-else> </span>
                </td>
                <td>
                  <span :style="{ 'color': (td.total < 0) ? 'red' : 'green' }">
                    {{ td.total }}
                  </span>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../../router";
import format from "date-fns/format";
export default {
   me: "main-output",
  data() {
    return {
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      logoSrc: "/assets/img/logo_light.png",
      title: "周生产计划",
      msg: "home",
      leftHeader: [], // 表头;
      leftValue: [], // 值;
      rightTopHeader: [], // 表头;
      rightTwoHeader: [], // 二级表头;
      rightValue: [], // 值;
      loading: null,
      issueDialog: false,
      todoDialog: false,
      issueData: {},
      todoData: {},
      colors: { Y: "#FFCC00", R: "#f44", G: "#06bf04" },
      todoTitle: { title: "", groupTitle: "" },
      screen: 1,
      pageSize: 16,
      too: 10000,
      now: null,
      week: null,
      updateTimeText: null
    };
  },
  mounted() {
    // this.onShow();
    this.loadBoardTitle();
    // 初始化
    this.startLoading();
    this.webSocket();
    this.init(); //保留http
    //钟表
    setInterval(this.clock, 1000);
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },

    init() {
      this.leftHeader = ["Product", "项目", "频次", "状态"];
      this.loadData();
    },

    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        API.getOeeOutPutList()
          .then((res) => {
            if (res.success === true) {
              this.format(res);
            }
          })
          .catch((error) => {
            this.endLoading();
            console.log(error);
          });
      }
    },
    //格式化数据
    format(res) {
      this.leftValue = [];
      this.leftValue = res.list
      if (res['isMon']) {
        this.title = "上周生产计划";
        this.week = null;
      }
      this.endLoading();
      var now = new Date();
      this.updateTimeText = format(now, "MM-dd HH:mm:ss");
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/oee/plan/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/oee/plan/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("OEE socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("OEE socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" OEE socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.pageSize = setUp["pageSize"];
        this.too = setUp["too"] * 1000;
      }
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>
<style>
.pagebgd {
  background: url("../../../../assets/img/8dbg.png");
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/oee/weektracking/output/board.vue